import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_DEDUCTIONS_PAYROLL_REQUEST = "GET_DEDUCTIONS_PAYROLL_REQUEST";
export const GET_DEDUCTIONS_PAYROLL_SUCCESS = "GET_DEDUCTIONS_PAYROLL_SUCCESS";
export const GET_DEDUCTIONS_PAYROLL_ERROR = "GET_DEDUCTIONS_PAYROLL_ERROR";

//* ACTIONS ------------------------------------------------
export const getDeductionsRequest = (payload = {}, callback) => ({
  type: GET_DEDUCTIONS_PAYROLL_REQUEST,
  payload,
  callback,
});

export const getDeductionsPayrollSuccess = (data) => ({
  type: GET_DEDUCTIONS_PAYROLL_SUCCESS,
  payload: data,
});

export const getDeductionsPayrollError = (error) => ({
  type: GET_DEDUCTIONS_PAYROLL_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getDeductionsPayrollServiceRequest = async ({
  payrollId,
  employeeId,
  ...params
}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(
    `/payrolls/${payrollId}/employees/${employeeId}/deductions`,
    options
  );
};
